import { makeVar } from '@apollo/client';

export default {
  headerCustomTheme: makeVar<string | null>(null)
};
